export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-array/src/identity.js
// module id = NNW9
// module chunks = 0